export const TELESALES_CHANNEL = 'televenta'
export const POS_CHANNEL = 'pos'
export const VISTA_POPUP_CHANNEL = 'vistaPopup'
export const VISTA_CHANNEL = 'vista'
